var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPharmacotherapyEvaluationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pharmacotherapyEvaluationIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#21272A",
  d: "M6.5 13A1.5 1.5 0 0 0 5 11.5H2a.501.501 0 0 1-.5-.5V2c0-.275.225-.5.5-.5h12c.275 0 .5.225.5.5v9c0 .275-.225.5-.5.5H9.666c-.325 0-.641.106-.9.3L6.5 13.5V13Zm-.006 2.381.006-.006L9.666 13H14c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2H2C.897 0 0 .897 0 2v9c0 1.103.897 2 2 2h3v2.5a.498.498 0 0 0 .8.4l.534-.4.16-.119ZM7 4v1.5H5.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5H7V9c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5V7.5h1.5c.275 0 .5-.225.5-.5V6c0-.275-.225-.5-.5-.5H9V4c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pharmacotherapyEvaluationIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgPharmacotherapyEvaluationIcon;